import { Button } from "./primitives";

export function WorkspaceError() {
  return (
    <main className="grid min-h-svh place-items-center bg-background p-6">
      <section className="max-w-sm space-y-4">
        <h1 className="text-xl font-semibold">This page couldn't open</h1>
        <p className="text-sm text-muted-foreground">
          Reload the page to try again. If you were saving, check the result before submitting
          again.
        </p>
        <Button variant="primary" onClick={() => window.location.reload()}>
          Reload page
        </Button>
      </section>
    </main>
  );
}
